import React, { useState } from "react";
import { AppBar, Toolbar, Button, Box } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import { Link } from "react-router-dom";
import Flag from "react-world-flags";
import { getFlagCode } from "../utils/getFlagCode";

import OccasionSelection from "./OccasionSelection";
import CountrySelection from "./CountrySelection";
import UniqueGiftsSelection from "./UniqueGiftsSelection";
import { Padding } from "@mui/icons-material";

const Navbar = ({ selectedCountry, setSelectedCountry }) => {
  const [occasionsDropdown, setOccasionsDropdown] = useState(null);
  const [countriesDropdown, setCountriesDropdown] = useState(null);
  const [uniqueGiftsDropdown, setUniqueGiftDropdown] = useState(null);

  const handleMenuOpen = (setter) => (event) => setter(event.currentTarget);
  const handleMenuClose = (setter) => () => setter(null);
  const flagCode = getFlagCode(selectedCountry);
  return (
    <AppBar position="static">
      <Toolbar
        style={{
          backgroundColor: "#FAEBD7",
          display: "flex",
          flexDirection: "row",
          minHeight: { xs: "auto", md: "64px" }, // Adjusts height dynamically
        }}
      >
        <div style={styles.container}>
          <div styles={styles.toolbarItem}>
            <Button style={{ color: "black" }} component={Link} to="/">
              <HomeIcon style={{ color: "black" }} />
            </Button>
          </div>
          <div styles={styles.toolbarItem}>
            <Button
              style={{ color: "black" }}
              onClick={handleMenuOpen(setOccasionsDropdown)}
            >
              Occasions ▼
            </Button>
          </div>
          <div styles={styles.toolbarItem}>
            <OccasionSelection
              occasionsDropdown={occasionsDropdown}
              setOccasionsDropdown={setOccasionsDropdown}
              handleMenuClose={handleMenuClose}
              selectedCountry={selectedCountry}
            />
          </div>
          <div styles={styles.toolbarItem}>
            {selectedCountry === "Canada" ? (
              <div>
                <Button
                  onClick={handleMenuOpen(setUniqueGiftDropdown)}
                  style={{ color: "black" }}
                >
                  Unique Gifts ▼
                </Button>
                <UniqueGiftsSelection
                  uniqueGiftsDropdown={uniqueGiftsDropdown}
                  setUniqueGiftDropdown={setUniqueGiftDropdown}
                  handleMenuClose={handleMenuClose}
                  selectedCountry={selectedCountry}
                />
              </div>
            ) : (
              <div />
            )}
          </div>
          <Button
            onClick={handleMenuOpen(setCountriesDropdown)}
            style={{
              display: "flex",
              flexWrap: "wrap",
              position: "absolute",
              right: 0,
              alignItems: "center",
              marginRight: 10,
              color: "black",
            }}
          >
            {flagCode !== "" && (
              <Flag code={flagCode} style={{ width: "25px", height: "15px" }} />
            )}
            ▼
          </Button>
          <div styles={styles.toolbarItem}>
            <CountrySelection
              countriesDropdown={countriesDropdown}
              setCountriesDropdown={setCountriesDropdown}
              handleMenuClose={handleMenuClose}
              setSelectedCountry={setSelectedCountry}
            />
          </div>
        </div>
      </Toolbar>
    </AppBar>
  );
};

const styles = {
  container: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
  },
  toolbarItem: {
    flex: 1,
  },
};

export default Navbar;
